import type { GridColTypeDef } from '@packages/fenrir/components/datagrid';
import { getGridDateRangeOperators } from '@packages/fenrir/components/datagrid';

import { DateTimeCell } from '../cell/datetime-cell/datetime-cell';

export const datetimeColumnType: GridColTypeDef = {
  display: 'flex',
  flex: 0.2,
  minWidth: 200,
  filterOperators: getGridDateRangeOperators(),
  renderCell: (params) => <DateTimeCell {...params} />,
};
